module.exports = __webpack_public_path__ + "img/6_49.f54ce045.png";